import { PurchasingService } from 'src/app/modules/planyard/purchasing.service';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-seasons-dialog',
  templateUrl: './seasons-dialog.component.html',
  styleUrls: ['./seasons-dialog.component.scss']
})
export class SeasonsDialogComponent implements OnInit, OnDestroy {
  seasons: any[];
  selectedSeason: any[] = [];
  actions = [
    {
      text: 'Cancel',
      buttonStyle: 'underline'
    },
    {
      text: 'Confirm',
    }
  ]
  private destroy$ = new Subject<void>();

  constructor(
    private purchasingService: PurchasingService,
    private dialogRef: MatDialogRef<SeasonsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    this.purchasingService.GetSeasons().pipe(takeUntil(this.destroy$)).subscribe((e: any[]) => {
      this.seasons = e;
      this.seasons.forEach(element => { 
        if (this.data.seasons.findIndex(x => x.seasonId === element.seasonId) > -1) {
          this.selectedSeason.push(element);
          element.isSelected = true;
        }
      })
    });
  };

  selectSeason(season) {
    const isSeasonSelected = this.selectedSeason.findIndex(e => e.seasonId === season.seasonId);
    if (isSeasonSelected != -1) {
      season.isSelected = false;
      this.selectedSeason.splice(isSeasonSelected, 1);
    } else {
      season.isSelected = true;
      this.selectedSeason.push(season);

    }
  }

  action(e: string) {
    if (e === 'Confirm') {
      this.dialogRef.close(this.selectedSeason);
    } else {
      this.dialogRef.close();
    }
  }

  close() {
    this.dialogRef.close();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

}
